import { activateModal } from "domains/modal/actions";
import type { ModalParams } from "domains/modal/types";

type TriggerLoginParams = Omit<ModalParams<"Authentication">, "hasDelay" | "isAlwaysWhite">;

export const triggerLogin = (params?: TriggerLoginParams) =>
  activateModal({ id: "Authentication", params: { ...params, hasDelay: true, isAlwaysWhite: true } });
